import { DefinedUseQueryResult, useQuery } from '@tanstack/react-query';

import { accountUserDetailKey } from '../../common/queryKeys';
import AccountUserApiV1 from '../../../../../../lib/api/account/user/AccountUserApiV1';
import { setRequestForm } from '../../../../../../lib/common';
import { PaginationType } from '../types/userDetailVisitorLog';
import { QueryOptions } from '../../../../../../types/query/useQuery';
import { UserDetailVisitorLogListResponseType } from '../types/userDetailVisitorLog';

type UseAccountUserDetailVisitorLogListQueryParamsType<SelectResultType> = {
  userId: number;
  pagination: PaginationType;
  options: QueryOptions<UserDetailVisitorLogListResponseType, Error, SelectResultType>;
};
export const useAccountUserDetailVisitorLogListQuery = <SelectResultType>({
  userId,
  pagination,
  options,
}: UseAccountUserDetailVisitorLogListQueryParamsType<SelectResultType>): DefinedUseQueryResult<
  SelectResultType,
  Error
> => {
  return useQuery<UserDetailVisitorLogListResponseType, Error, SelectResultType>(
    [...accountUserDetailKey, 'visitorLog', userId, pagination],
    async () => {
      const result = await AccountUserApiV1.getAccountUserDetailVisitorLogList(
        setRequestForm({ userId, pagination }, true),
      );
      if ('msg' in result) throw new Error(result.msg);
      return result;
    },
    { ...options, initialData: { data: { visitorTimeLineList: { list: [], totalCnt: 0 } }, status: 0 } },
  );
};
